import BetCard from './BetCard';

export default BetCard;
